import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import './MDAuditoria.css';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as auditoriaService from '../../services/auditoria/auditoriaService';
import { formatEntidadId, formatEntidadNombre, AUDITORIA_ENTIDAD_OPTIONS } from '../../services/auditoria/auditoriaDto';

const ACCIONES = ['Alta', 'Baja', 'Modificacion', 'Generacion'];

const ACCION_LABELS = {
  Alta: 'Alta',
  Baja: 'Baja',
  Modificacion: 'Modificación',
  Generacion: 'Generación',
};

function formatFechaHora(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString('es-AR');
}

function formatJsonPreview(value) {
  if (!value) {
    return '—';
  }
  try {
    const parsed = JSON.parse(value);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return value;
  }
}

function getAccionLabel(accion) {
  return ACCION_LABELS[accion] || accion || '—';
}

export class MDAuditoria extends Component {
  static displayName = MDAuditoria.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      paginationData: [],
      perPage: 25,
      pageCount: 0,
      forcePage: 0,
      searched: false,
      showErrorMessage: false,
      errorMessage: '',
      totalCount: 0,
      filters: {
        usuarioNombre: '',
        entidad: '',
        accion: '',
        fechaDesde: '',
        fechaHasta: '',
      },
    };

    this.grid = createPagedGridController({
      fetchPage: (query) => auditoriaService.listAuditoria(query),
      defaultPageSize: 25,
      onChange: (gridState) => this.applyGridState(gridState),
    });

    this.handleBuscar = this.handleBuscar.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAuditoria');
    if (canAccess) {
      this.setState({ searched: false });
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      totalCount: gridState.totalCount,
      showErrorMessage: !!gridState.error,
      errorMessage: gridState.error?.message || '',
    });
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [name]: value,
      },
      showErrorMessage: false,
      errorMessage: '',
    }));
  };

  handleBuscar = async (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      searched: true,
      showErrorMessage: false,
      errorMessage: '',
    });

    try {
      await this.grid.handleFiltersChange({ ...this.state.filters });
    } catch (error) {
      this.setState({
        showErrorMessage: true,
        errorMessage: error?.message || 'No se pudo cargar la auditoría.',
      });
    }
  };

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => {
      this.setState({
        showErrorMessage: true,
        errorMessage: error?.message || 'No se pudo cargar la auditoría.',
      });
    });
  };

  renderTable(items) {
    return (
      <div className="md-page__table-card md-auditoria__table-wrap">
        <table className="md-page__table md-auditoria__table" aria-labelledby="auditoria-title">
          <colgroup>
            <col className="md-auditoria__col-fecha" />
            <col className="md-auditoria__col-usuario" />
            <col className="md-auditoria__col-accion" />
            <col className="md-auditoria__col-entidad" />
            <col className="md-auditoria__col-id" />
            <col className="md-auditoria__col-detalle" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Usuario</th>
              <th scope="col">Acción</th>
              <th scope="col">Nombre de entidad</th>
              <th scope="col">ID entidad</th>
              <th scope="col">Detalle</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.auditoriaCambioId}>
                <td className="md-auditoria__cell">{formatFechaHora(item.auditoriaCambioFecha)}</td>
                <td className="md-auditoria__cell">{item.usuarioNombre || '—'}</td>
                <td className="md-auditoria__cell md-auditoria__cell--accion">
                  {getAccionLabel(item.auditoriaCambioAccion)}
                </td>
                <td className="md-auditoria__cell">
                  {item.auditoriaCambioEntidadNombre || formatEntidadNombre(item.auditoriaCambioEntidad)}
                </td>
                <td className="md-auditoria__cell">{formatEntidadId(item.auditoriaCambioEntidadId)}</td>
                <td className="md-auditoria__cell md-auditoria__cell--detalle">
                  <details className="md-auditoria__detalle">
                    <summary>Ver cambios</summary>
                    {item.auditoriaCambioValoresAnteriores ? (
                      <div className="md-auditoria__detalle-block">
                        <strong>Antes:</strong>
                        <pre>{formatJsonPreview(item.auditoriaCambioValoresAnteriores)}</pre>
                      </div>
                    ) : null}
                    {item.auditoriaCambioValoresNuevos ? (
                      <div className="md-auditoria__detalle-block">
                        <strong>Después:</strong>
                        <pre>{formatJsonPreview(item.auditoriaCambioValoresNuevos)}</pre>
                      </div>
                    ) : null}
                    {!item.auditoriaCambioValoresAnteriores && !item.auditoriaCambioValoresNuevos ? (
                      <span>—</span>
                    ) : null}
                  </details>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {
      loading,
      searched,
      paginationData,
      pageCount,
      forcePage,
      perPage,
      filters,
      showErrorMessage,
      errorMessage,
    } = this.state;

    const hasResults = !loading && searched && paginationData.length > 0;
    const noResults = !loading && searched && paginationData.length === 0;

    return (
      <div className="md-page md-form-page consultar-auditoria">
        <h1 id="auditoria-title" className="md-page__title">Auditoría de cambios del sistema</h1>
        <p className="md-form-page__subtitle">
          Consulta de solo lectura. Registra altas, bajas, modificaciones y generaciones en entidades críticas.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {errorMessage}
            </div>
          ) : null}
        </div>

        <div className="md-form-page__card md-auditoria__filters-card">
          <form className="md-form-page__form md-auditoria__filters-form" onSubmit={this.handleBuscar} noValidate>
            <div className="md-auditoria__filters-bar">
              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-usuario">
                  Usuario
                </label>
                <input
                  id="aud-usuario"
                  className="md-form-page__input"
                  type="text"
                  name="usuarioNombre"
                  placeholder="Usuario"
                  value={filters.usuarioNombre}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-entidad">
                  Entidad
                </label>
                <select
                  id="aud-entidad"
                  className="form-control app-native-select"
                  name="entidad"
                  value={filters.entidad}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                >
                  <option value="">Todas</option>
                  {AUDITORIA_ENTIDAD_OPTIONS.map((entidad) => (
                    <option key={entidad.value} value={entidad.value}>{entidad.label}</option>
                  ))}
                </select>
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-accion">
                  Acción
                </label>
                <select
                  id="aud-accion"
                  className="form-control app-native-select"
                  name="accion"
                  value={filters.accion}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                >
                  <option value="">Todas</option>
                  {ACCIONES.map((accion) => (
                    <option key={accion} value={accion}>{getAccionLabel(accion)}</option>
                  ))}
                </select>
              </div>

              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="aud-fecha-desde">
                  Desde
                </label>
                <input
                  id="aud-fecha-desde"
                  className="md-form-page__input"
                  type="date"
                  name="fechaDesde"
                  value={filters.fechaDesde}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="aud-fecha-hasta">
                  Hasta
                </label>
                <input
                  id="aud-fecha-hasta"
                  className="md-form-page__input"
                  type="date"
                  name="fechaHasta"
                  value={filters.fechaHasta}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary md-auditoria__search-btn"
                disabled={loading}
              >
                Buscar
              </button>
            </div>
          </form>
        </div>

        {loading ? (
          <p className="md-page__loading"><em>Cargando resultados...</em></p>
        ) : null}

        {noResults ? (
          <p className="md-page__empty"><em>No hay resultados</em></p>
        ) : null}

        {hasResults ? this.renderTable(paginationData) : null}

        {hasResults && pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={forcePage}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }
}
